import * as React from "react";
// import components
import {
  Content,
  ThreadItemFooterLeft,
  ThreadItemFooterRight,
  ThreadItemWrapper,
  ThreadItemLeft,
  ThreadItemBody,
  ThreadItemExtra,
  ThreadItemFooter,
  ThreadItemTitle,
} from "./styledComponents";
import { ThreadHiddenDeem } from "common/components/thread/components/threadWrapper/styledComponents";

interface IProps extends React.HTMLProps<any> {
  isHidden?: boolean;
  minimum?: boolean;
  left?: JSX.Element | null;
  header?: JSX.Element | null;
  body?: JSX.Element | null;
  footerLeft?: JSX.Element | null;
  footerRight?: JSX.Element | null;
  extra?: JSX.Element | null;
}

class ThreadItem extends React.PureComponent<IProps> {
  public render() {
    const {
      isHidden,
      left,
      header,
      body,
      footerLeft,
      footerRight,
      extra,
      className,
      as,
      ref,
      minimum,
      ...rest
    } = this.props;

    return (
      <ThreadItemWrapper
        minimum={Boolean(minimum)}
        className={`${className || ""} clearfix`}
        {...rest}
      >
        {isHidden && <ThreadHiddenDeem />}
        <ThreadItemLeft>{left}</ThreadItemLeft>
        <ThreadItemBody>
          <ThreadItemTitle>{header}</ThreadItemTitle>
          <Content>{body}</Content>
          {footerLeft || footerRight ? (
            <ThreadItemFooter>
              {footerLeft ? (
                <ThreadItemFooterLeft>{footerLeft}</ThreadItemFooterLeft>
              ) : null}
              {footerRight ? (
                <ThreadItemFooterRight>{footerRight}</ThreadItemFooterRight>
              ) : null}
            </ThreadItemFooter>
          ) : null}
          {extra ? <ThreadItemExtra>{extra}</ThreadItemExtra> : null}
        </ThreadItemBody>
      </ThreadItemWrapper>
    );
  }
}

export default ThreadItem;
